import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { EjendomSearchResponse, EjendomSted } from '../../../api/models';
import { EjendommeService } from '../../../api/services';
import { FormHelper } from '../../helpers/form-helper';
import { NotificationService } from '../../notifications/notification.service';
import { TekstResourcePipe } from '../../pipes/tekstresource.pipe';
import { EjendomsoegningService } from './services/ejendomsoegning.service';

@Component({
  selector: 'bom-ejendomsoegning',
  templateUrl: './ejendomsoegning.component.html',
  styleUrls: ['./ejendomsoegning.component.scss'],
})
export class EjendomsoegningComponent implements OnInit, OnDestroy {
  @Input()
  searchClicked: Observable<any>;

  @Output()
  searchButtonToggle = new EventEmitter<boolean>();

  @Output()
  searchEjendomSted = new EventEmitter<EjendomSted>();

  @Output()
  valgtStedLoadingToggle = new EventEmitter<boolean>();

  searchSubscription: Subscription;
  form: FormGroup;

  get bfeValidator() {
    return this.form.get('bfeValidator');
  }

  constructor(
    public ejendomSoegningService: EjendomsoegningService,
    private ejendomsService: EjendommeService,
    private notificationService: NotificationService,
    private tekstResourcePipe: TekstResourcePipe
  ) {
    this.form = new FormGroup({
      bfeValidator: FormHelper.OnlyDigitsWithspaces,
    });
  }

  ngOnInit(): void {
    this.searchSubscription = this.searchClicked.subscribe(() => {
      this.searchEjendom();
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }

  isBfeNummerInputValid(): boolean {
    return !this.bfeValidator.errors && this.bfeValidator.value;
  }

  onChangeBfeNummer() {
    if (this.isBfeNummerInputValid()) {
      this.searchButtonToggle.next(true);
    } else {
      this.searchButtonToggle.next(false);
    }
  }

  searchEjendom() {
    FormHelper.RemoveWhitespace(this.bfeValidator);
    if (FormHelper.FormControlValid(this.bfeValidator)) {
      if (this.bfeValidator.value.length > FormHelper.BfeNrLength) {
        this.bfeValidator.setErrors({ maxlength: true });
        return;
      }
      this.valgtStedLoadingToggle.next(true);
      this.ejendomsService
        .search(this.bfeValidator.value)
        .subscribe((response: EjendomSearchResponse) => {
          if (response.externalCallSuccess) {
            this.searchEjendomSted.emit(response.ejendom);

            if (!response.ejendom) {
              this.bfeValidator.setErrors({ noEjendomFound: true });
            }
          } else {
            this.notificationService.warn(
              this.tekstResourcePipe.transform('Fejl.Notifikation.EksternSystem.Error'),
              null,
              response.correlationId
            );
          }
        });
    } else {
      if (!this.bfeValidator.value) {
        this.bfeValidator.setErrors({ onlyDigits: true });
      }
    }
  }
}
